import { IoFilter } from "react-icons/io5";
import { RxCross1 } from "react-icons/rx";
import { useHistory } from "react-router-dom";
import Pagination from "../../components/pagination";
import { ROLE } from "../../constants/common";
import { checkIsAllowed } from "../../helpers/helpers";
import cn from "../../lib/cn";
import Container from "../../shared/Container";
import P from "../../shared/typography/P";
import Tag from "../../shared/ui/tag/Tag";
import ProposalList from "./ProposalList";

const columns = [
    "ID",
    "Project Name",
    "Date",
    "Assignee",
    "Proposal Count",
    "Action",
];

const DashBoardTable = ({
    roles,
    data,
    paginationData,
    onPageChange,
    handleChange,
    selectedFilter,
    onFilterChange,
    ProposalGen,
    setShowModal,
    formData,
    handleRemoveSearchValue,
}) => {
    const history = useHistory();

    return (
        <Container className="px-1 pb-5 mb-3 md:mb-0 lg:max-w-max  lg:m-0 lg:p-0 ">
            <div className="w-full">
                <div className="flex justify-between  md:gap-[7rem] pt-2  w-full items-center border-b border-b-blue-250  sticky top-0 bg-white z-10">
                    <div
                        role="button"
                        onClick={() => {
                            onFilterChange("All");
                            if (!ProposalGen) {
                                handleChange();
                            }
                        }}
                        className={cn("pb-2", {
                            "border-b-2 border-b-blue ":
                                selectedFilter === "All" && ProposalGen,
                            hidden: !checkIsAllowed(roles, [ROLE.SUPER_ADMIN]),
                        })}
                    >
                        <P className="text-nowrap">All</P>
                    </div>
                    <div
                        role="button"
                        onClick={() => {
                            onFilterChange("Mine");
                            if (!ProposalGen) {
                                handleChange();
                            }
                        }}
                        className={cn("pb-2", {
                            "border-b-2 border-b-blue ":
                                selectedFilter === "Mine" && ProposalGen,
                        })}
                    >
                        <P className="text-nowrap">Mine</P>
                    </div>
                    <div
                        role="button"
                        onClick={() => {
                            handleChange();
                            onFilterChange("All");
                        }}
                        className={cn("pb-2", {
                            "border-b-2 border-b-blue ": !ProposalGen,
                        })}
                    >
                        <P className="text-nowrap">Not Generated</P>
                    </div>
                    <div
                        role="button"
                        className="pb-2"
                        onClick={() => {
                            setShowModal((prev) => !prev);
                        }}
                    >
                        <P>
                            <IoFilter />
                        </P>
                    </div>
                </div>

                <div className="flex items-center gap-3 mb-2">
                    {formData?.propertyName && (
                        <Tag
                            text={formData?.propertyName}
                            className={" bg-gray-100 rounded-xl p-0.2"}
                            icon={<RxCross1 />}
                            onClick={() =>
                                handleRemoveSearchValue("propertyName")
                            }
                            textClass={
                                "text-secondary  gap-0.5 text-nowrap !text-xs"
                            }
                        />
                    )}
                    {formData?.searchName && (
                        <Tag
                            text={formData?.searchName}
                            className={" bg-gray-100 rounded-xl p-0.2"}
                            icon={<RxCross1 />}
                            onClick={() =>
                                handleRemoveSearchValue("searchName")
                            }
                            textClass={
                                "text-secondary  gap-0.5 text-nowrap !text-xs"
                            }
                        />
                    )}
                </div>
                <ProposalList data={data} />
            </div>

            <div className="sticky bottom-0 z-10 bg-white p-1 pb-[8rem] lg:pb-1">
                {paginationData && (
                    <Pagination
                        isFirst={paginationData.isFirst}
                        isLast={paginationData.isLast}
                        pageCount={paginationData.pageCount}
                        onChange={onPageChange}
                        forcePage={paginationData.pageNumber}
                    />
                )}
            </div>
        </Container>
    );
};

export default DashBoardTable;
